module.exports = __webpack_public_path__ + "img/组件6.d82fc335.png";